import {
  AppBar,
  Box,
  Button,
  Container,
  Stack,
  Toolbar,
  Typography,
  useTheme,
} from '@mui/material'
import { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useRecoilValue } from 'recoil'
import { useSign } from '../../hooks/sign'
import { useUser } from '../../hooks/user'
import { gymState } from '../../store/gym'
import { SupportChat } from '../SupportChat'
import { MySchedule } from './MySchedule'

const Header: FC = () => {
  const gym = useRecoilValue(gymState)
  const { t } = useTranslation()
  const theme = useTheme()

  const { user } = useUser()
  const { start: sign, element: signElement } = useSign()

  const handleSignClick = useCallback(() => {
    sign()
  }, [sign])

  return (
    <>
      <AppBar>
        <Container>
          <Toolbar>
            <Box
              component="img"
              src={gym?.gym_logo}
              alt={gym?.name}
              sx={{ maxBlockSize: theme.spacing(6) }}
            />
            <Typography variant="h2" flexGrow={1}>
              {gym?.name}
            </Typography>
            {user ? (
              <Stack direction="row" spacing={1}>
                <SupportChat />
                <MySchedule />
              </Stack>
            ) : (
              <Button variant="outlined" onClick={handleSignClick}>
                {t('Sign in or Sign up')}
              </Button>
            )}
          </Toolbar>
        </Container>
      </AppBar>
      <Toolbar />
      {signElement}
    </>
  )
}

export { Header }
